import React from "react"
import { Typography, Card } from "antd"
import { Animated } from "react-animated-css"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Layout from "../../components/Layout"
import TrustedBy from "../../components/TrustedBy"
import FeaturedWork from "../../components/MOB_FeaturedWork"
import DevelopmentProcess from "../../components/WEB_DevelopmentProcess"
import TechStack from "../../components/MOB_TechStack"
import CtaBanner from "../../components/MOB_CtaBanner"
import SideForm from "../../components/SideForm"
import "../../styles/services.scss"
import "../../styles/animate.css"
import ServiceCard from "../../components/ServiceCard"
import mobileapp_development from '../../images/mobile/mobile_Dev 1.png'
import mobile_design from '../../images/mobile/mobile_design 1.png'
import mobile_testing from '../../images/mobile/mobile_testing 1.png'
import mobile_integration from '../../images/mobile/mobile_integration 1.png'
import deployment_img from '../../images/deployment-01.png'
import behindImageSmall from "../../images/Group 495@2x.png"
import ServiceStepsProcess from "../../components/ServiceStepsProcess"
import IconsAdded from "../../components/IconsAdded"

const { Title } = Typography

const Index = ({ data }) => {
  const backgroundImage = data.bgImage.childImageSharp.fluid.src
  return (
    <Layout className="services-page-container" data={data} 
    pageTitle={"Visiomate - Mobile Development Services"}
    descrip = {"Bring your mobile app ideas to life. Our expert mobile development services deliver high-quality, user-friendly apps for iOS and Android. Contact us today!"}>
      <div className="top-section"
        style={{ backgroundImage: `url(${backgroundImage})` }}>
        {/* <div className="logo">
          <Link to="/">
            <Img fluid={data.VMLogoWhite.childImageSharp.fluid} />
          </Link>
        </div> */}
        <div className="box-wrapper text-and-form-container" style={{ gridTemplateColumns: '1fr', textAlign: 'center' }}>
          <div className="information">
            <Animated
              animationIn="fadeInUp"
              animationInDuration={500}
              animationInDelay={300}
              isVisible={true}
            >
              <Title>AI-Powered Mobile Apps for iOS & Android</Title>
              <br />
              <p>
                We design and build intelligent mobile applications that embed AI features — smart search, personalised recommendations, and predictive UX — directly into the native experience.
                Whether you're targeting iOS, Android, or both, our engineering teams deliver cross-platform apps that perform at scale and continuously improve with your users.
              </p>
              {/* <TrustedBy showHeading={false} /> */}
            </Animated>
          </div>
          {/* <Animated
            animationIn="fadeInDown"
            animationInDuration={800}
            animationInDelay={500}
            isVisible={true}
            className="form"
          >
            <SideForm />
          </Animated> */}
        </div>
      </div>
      <div className="services-description-section">
      <div className="service-heading-and-detail">
        <Title>What We Can Build For You</Title>
      </div>
      <div className="service-cards-wrapper">
        <ServiceCard img_src={mobileapp_development} img_alt={'AI mobile app development for iOS and Android'} card_heading={'Ship a High-Performance Native App'} card_para={"Your users expect fast, reliable experiences from day one. We build iOS and Android apps with AI features embedded — smart search, personalised feeds, and predictive actions — so your app stands out and retains users."}/>
        <ServiceCard img_src={mobile_design} img_alt={'Mobile UI/UX design to reduce user churn'} card_heading={'Turn First-Time Users Into Loyal Customers'} card_para={'Most users abandon apps with poor UX within seconds. We design intuitive, AI-informed interfaces that guide users naturally, reduce friction, and make every interaction feel effortless.'}/>
        <ServiceCard img_src={mobile_integration} img_alt={'Mobile app API and backend integration'} card_heading={'Connect Your App to Every System You Use'} card_para={"Siloed apps limit what your business can do. We integrate your mobile app with your ERP, CRM, payment gateways, and third-party services through secure, high-performance APIs."}/>
        <ServiceCard img_src={mobile_testing} img_alt={'Legacy mobile app modernisation with AI'} card_heading={'Modernise Before Your Users Walk Away'} card_para={'Outdated mobile apps lose ratings, users, and revenue. We upgrade legacy apps with modern architectures and AI capabilities — without starting from scratch.'}/>
        <ServiceCard img_src={deployment_img} img_alt={'Post-launch mobile app support and monitoring'} card_heading={'Stay Live and Supported After Launch'} card_para={'Going live is the start, not the finish. We provide proactive post-launch support, monitoring, and rapid-response fixes so your app performs reliably as your user base grows.'}/>
        <ServiceCard card_heading={'Let connect, book a free consultancy session with our experts'} card_button={"Free Consultancy"}/>
      </div>
        {/* <div className="behindimagediv">
            <img
              className="behindImageSmall"
              src={behindImageSmall}
              alt="yellow-triangle"
            />
            <img className="behindImageLarg" src={behindImageSmall} alt="yellow-triangle" />
        </div> */}
      </div>
      <div className="featured-projects position-relative">
        <FeaturedWork data={data} />
        {/* <IconsAdded/> */}
      </div>
      <DevelopmentProcess title='How We Turn Your Idea Into a Shipped Product' >
        <ServiceStepsProcess process_heading='Inception & Elicitation' process_para="Talk to the customer Listen to what the customer has to say Brainstorm and prepare project backlog." process_step_number="1" process_indentify="odd" />
        <ServiceStepsProcess process_heading='UI/UX Design' process_para="Create user-friendly interfaces and engaging experiences. This includes wireframing, prototyping, and establishing a cohesive visual style that enhances usability." process_step_number="2"  />
        <ServiceStepsProcess process_heading='Plan sprint' process_para="The team reviews the product backlog and selects items they believe can be completed within the sprint timeframe." process_step_number="3" process_indentify="odd" iconShow="dark"/>
        <ServiceStepsProcess process_heading='Execute Sprint' process_para="The team focuses on completing the items in the sprint backlog, which consists of tasks selected from the product backlog based on priority and team capacity." process_step_number="4" iconShow="dark" />
        <ServiceStepsProcess process_heading='Review' process_para="During this step, the development team showcases the work completed, demonstrating new features and functionalities to the customer." process_step_number="5" process_indentify="odd" />
        <ServiceStepsProcess process_heading='Deployment & Support' process_para="Once testing is complete, the app is released to users through platforms like the Apple App Store or Google Play Store." process_step_number="6" />
      </DevelopmentProcess>
      <TechStack />
      <CtaBanner />
    </Layout>
  )
}

export default Index

export const mobileDevelopmentQuery = graphql`
  query mobileDevelopmentQuery {
    FarmManagementSystem: file(
      relativePath: { eq: "FarmManagementSystem/pf.jpg" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    TenderAssetRecordManagement: file(
      relativePath: { eq: "TenderAssetRecordManagement/tender.jpg" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    ViztosPos: file(relativePath: { eq: "ViztosPos/vistos_image.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Odoo2: file(relativePath: { eq: "Odoo/odoo2.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Custom: file(relativePath: { eq: "Custom/CustDevelopment.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    D365_2: file(relativePath: { eq: "D365/D365_2.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }

    VMLogoWhite: file(relativePath: { eq: "logo_white_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bgImage: file(relativePath: { eq: "Mask_group8.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    SNGPL: file(relativePath: { eq: "mobile/SNGPLApp-01.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    SBP: file(relativePath: { eq: "mobile/statebankapp.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    BigJerry: file(relativePath: { eq: "mobile/BigJerryApp.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    UmrahShuttle: file(relativePath: { eq: "mobile/umrahshuttleapp.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
